import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import HomeScreen from '../screens/home/HomeScreen';
import CreatePostScreen from '../screens/CreatePostScreen';
import PostDetailScreen from '../screens/PostDetailScreen';
import { Post } from '../lib/api/feed';

export type HomeStackParamList = {
  Home: undefined;
  CreatePost: { clubId?: string; mode?: 'create' | 'edit'; post?: Post };
  PostDetail: { post: Post };
};

const Stack = createStackNavigator<HomeStackParamList>();

const HomeNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="Home" component={HomeScreen} />
      <Stack.Screen name="CreatePost" component={CreatePostScreen} />
      <Stack.Screen 
        name="PostDetail" 
        component={PostDetailScreen}
      />
    </Stack.Navigator>
  );
};

export default HomeNavigator;
